// Camera RAW extensions the platform accepts; browsers report an empty or vendor MIME for them, so the extension decides.
export const RAW_EXTENSIONS = ['cr2', 'cr3', 'nef', 'arw', 'dng', 'raf', 'orf', 'rw2'] as const;

// A RAW shows its preview versions like any photo; preview surfaces fall back to a RAW badge only
// while it has none (still being cut, or a RAW the platform cannot preview).
export function isRawName(name: string | null): boolean {
  const ext = name?.split('.').pop()?.toLowerCase() ?? '';
  return (RAW_EXTENSIONS as readonly string[]).includes(ext);
}
